// src/Component/former/Former.js
import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import './roll.css'; // Import the CSS for styling
import roll1 from '../../image/roll1.png';

const Roll = () => {
  return (
    <div className="details-container">

      {/* SEO Meta Tags */}
      <Helmet>
        <title>Roll Cleaner or Cleaning Machine</title>
        <meta
          name="description"
          content="Roll Cleaner or Cleaning Machine. P. Rakesh Industries offers advanced roll cleaner solutions, including automatic roller cleaning machines, backing roll cleaners, and roll surface cleaning systems. Ensure uniform product quality, seamless cleaning during production, and easy maintenance with our efficient roll cleaning tools and OEM roll cleaner units in India."
        />
        <meta
          property="og:title"
          content="Roll Cleaner or Cleaning Machine"
        />
        <meta
          property="og:description"
          content="Roll Cleaner or Cleaning Machine. P. Rakesh Industries offers advanced roll cleaner solutions, including automatic roller cleaning machines, backing roll cleaners, and roll surface cleaning systems. Ensure uniform product quality, seamless cleaning during production, and easy maintenance with our efficient roll cleaning tools and OEM roll cleaner units in India."
        />
        <meta property="og:url" content="https://pripapermachines.com/roll-cleaner-cleaning-machine" />
        <link rel="canonical" href="https://pripapermachines.com/roll-cleaner-cleaning-machine" />
      </Helmet>

      <div className="details-content">
        {/* Left Column */}
        <div className="column left">
          <div>
            <h1 style={{color:"#4d7544",fontSize:"44px",textAlign:"left" ,marginTop:"-10px"}} className='viewfordesktop'>ROLL CLEANER</h1>
            <img src={roll1} alt="Roll Cleaner" />
          </div>
        </div>

        {/* Right Column */}
        <div className="column right">
          <div className="column-right">
            <h1 style={{color:"#4d7544",fontSize:"34px",textAlign:"left",marginTop:"10px",fontSize:"26px"}}>Key Features:</h1>
            <ul style={{color:"black",textAlign:"left"}}>
              <li>The equipment is needful where the roll is difficult to access.</li> 
              <br />
              <li>Uniform product quality thanks to roll cleaning equipment, resulting in no more complain of coated surface.</li>
              <br />
              <li>Equipment can be run constantly or as per cleaning requirements.</li>
              <br />
              <li>No interruption during production, as cleaning is possible during the continuous process during continuous process, results in increased productivity.</li>
              <br />
              <li>Easy and quick change of cleaning sponge thanks to Velcro fastening.</li>
              <br />
              <li>A mist spray nozzle at the cleaning sponge is used for removing extremely sticky particles.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Roll;
